export default "__VITE_ASSET__D3X1O0dj__"